import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../../../app/configcontext';
import { useDispatch } from 'react-redux';
import { businessSlice } from '../../../../../features/business/businessSlice';
import ProtectedPaymentRoute from '../../../../auth/Auth';

export default function Tax() {
  ProtectedPaymentRoute();

  const config = useConfig();
  const actions = businessSlice.actions;
  const dispatch = useDispatch();
  const taxExperts = config?.taxExperts || [];
  const navigate = useNavigate();

  const handleNextButtonClick = (event, id) => {
    event.preventDefault();
    dispatch(actions.update_tax(id));
    navigate("/corp_question/6");
  };

  const handleSkip = () => {
    navigate("/corp_question/6");
  };

  const backbtn = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-5xl">
        <div className="mb-10 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Dedicated Small Business Tax Advisory
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Maximize your deductions with corporate tax specialists
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Rely on experienced CPAs and tax attorneys to take care of corporate filings and quarterly estimates with 100% accuracy guarantee.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10 max-w-4xl mx-auto">
          {taxExperts.map((ele) => (
            <div
              key={ele.id}
              className="p-8 rounded-[16px] border border-[#dadce0] bg-white shadow-sm hover:border-[#1a73e8]/40 hover:shadow-md transition-all flex flex-col justify-between"
            >
              <div>
                <div className="w-12 h-12 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] text-xl mb-5">
                  <i className="fa-solid fa-calculator" aria-hidden="true"></i>
                </div>
                <h3 className="text-xl font-medium text-[#202124] mb-1">{ele.name}</h3>
                <span className="text-xs text-[#1a73e8] font-medium block mb-4">{ele.shortDescription}</span>
                <p className="text-[14px] text-[#5f6368] leading-relaxed mb-6">
                  {ele.description}
                </p>
              </div>

              <div>
                <div className="flex items-baseline gap-1 mb-6">
                  <span className="text-3xl font-bold text-[#202124]">${ele.price}</span>
                  <span className="text-sm text-[#5f6368]">/month</span>
                </div>

                <button
                  type="button"
                  onClick={(event) => handleNextButtonClick(event, ele.id)}
                  className="w-full py-3 rounded-[6px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all text-[14.5px] cursor-pointer"
                >
                  Select Tax Plan
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-[#f1f3f4] max-w-4xl mx-auto">
          <button
            type="button"
            onClick={backbtn}
            className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
          >
            <i className="fa-solid fa-arrow-left text-xs"></i> Back
          </button>
          <button
            type="button"
            onClick={handleSkip}
            className="text-[14px] text-[#5f6368] hover:text-[#1a73e8] underline transition-colors cursor-pointer bg-transparent border-none"
          >
            No, thanks — I'll handle corporate taxes on my own
          </button>
        </div>
      </div>
    </div>
  );
}